module.exports = __webpack_public_path__ + "static/media/paidImage.b63e6caa.png";